import { formatDayRange } from '@/libs/dayjs'
import type { ITaskMin } from '@/types/Task'

/*
 * What a schedule change did to the rest of the plan, in one line per moved task:
 * "NAB-13 → 3. 10. – 12. 10., NAB-14 → 13. 10." The server moves successors later so that
 * each starts the day after its latest predecessor ends (docs/API.md → Scheduling rules);
 * whoever caused it is told which, because they did not touch those tasks themselves.
 */
export const formatShifted = (shifted: ITaskMin[]): string => shifted
    .map((task) => `${task.key} → ${formatDayRange(task.start_date, task.due_date)}`)
    .join(', ')
